import { useCallback } from 'react';
import { TextField, withStyles } from 'vopay';
import { PermissionFieldRenderer } from '../types';
import PermissionToggle from '../PermissionToggle/PermissionToggle';
import styles from './Permission.module.scss';

const cn = withStyles(styles);

/**
 * The control for one item, by `type`. Memoized because the engine's field config depends on it. Both number
 * presets mask non-numeric input, so the engine's finite-number validation is only a backstop and no error
 * message is shown.
 */
export default function usePermissionFieldRenderer(currency: string, readOnly: boolean): PermissionFieldRenderer {
  return useCallback<PermissionFieldRenderer>(
    (item, { getFormikData }) => {
      if (item.type === 'boolean') {
        const field = getFormikData<boolean>({});

        return (
          <PermissionToggle name={field.name} checked={!!field.value} disabled={readOnly} onChange={field.onChange} />
        );
      }

      const field = getFormikData<string>({});

      if (item.type === 'number') {
        return (
          <TextField
            variant="outlineShadow"
            preset={item.isCurrency ? 'currency' : 'numericWholePositive'}
            elementLeft={item.isCurrency ? <span className={cn('currencyLabel')}>{currency}</span> : undefined}
            name={field.name}
            value={String(field.value)}
            disabled={readOnly}
            onBlur={field.onBlur}
            onChange={field.onChange}
          />
        );
      }

      return (
        <TextField
          variant="outlineShadow"
          name={field.name}
          value={field.value}
          disabled={readOnly}
          onBlur={field.onBlur}
          onChange={field.onChange}
        />
      );
    },
    [currency, readOnly],
  );
}
